export default (str: string): string => str.replaceAll(/\s+/g, " ").trim();
